// ReadingBasis, shows the exact natal data used for a reading.
// Proves personalisation by surfacing the specific planets/degrees computed.
import { getSignName } from '../../lib/astrology';

interface ReadingBasisProps {
  sunSign?: string;
  sunDegree?: number;
  moonSign?: string;
  ascendantSign?: string;
  ascendantDegree?: number;
  /** Number of active transits used today (optional) */
  transitCount?: number;
  /** Extra context string to show after the natal items */
  extra?: string;
  /** When provided, replaces the astrological detail line with the user's first name */
  userName?: string;
  className?: string;
}

export function ReadingBasis({
  sunSign,
  sunDegree,
  moonSign,
  ascendantSign,
  ascendantDegree,
  transitCount,
  extra,
  userName,
  className = '',
}: ReadingBasisProps) {
  const toLabel = (key?: string) => key ? (getSignName(key) || key) : '';

  if (userName) {
    return (
      <div
        className={className}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.4rem',
          fontSize: '0.75rem',
          color: 'var(--text-tertiary)',
          borderTop: '1px solid var(--border-faint, rgba(255,255,255,0.06))',
          paddingTop: '0.75rem',
          marginTop: '1rem',
          flexWrap: 'wrap',
        }}
      >
        <span style={{ color: 'var(--petrol)', flexShrink: 0 }}>✦</span>
        <span>Previsão personalizada para você: {userName}</span>
      </div>
    );
  }

  const items: string[] = [];

  if (sunSign) {
    const label = toLabel(sunSign);
    items.push(`Sol em ${label}${sunDegree !== undefined ? ` ${sunDegree.toFixed(1)}°` : ''}`);
  }
  if (moonSign) {
    items.push(`Lua em ${toLabel(moonSign)}`);
  }
  if (ascendantSign) {
    items.push(`ASC em ${toLabel(ascendantSign)}${ascendantDegree !== undefined ? ` ${ascendantDegree.toFixed(1)}°` : ''}`);
  }
  if (transitCount !== undefined && transitCount > 0) {
    items.push(`${transitCount} trânsitos ativos hoje`);
  }
  if (extra) {
    items.push(extra);
  }

  if (items.length === 0) return null;

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.4rem',
        fontSize: '0.75rem',
        color: 'var(--text-tertiary)',
        borderTop: '1px solid var(--border-faint, rgba(255,255,255,0.06))',
        paddingTop: '0.75rem',
        marginTop: '1rem',
        flexWrap: 'wrap',
      }}
    >
      <span style={{ color: 'var(--petrol)', flexShrink: 0 }}>✦</span>
      <span>Personalizado para você: {items.join(' · ')}</span>
    </div>
  );
}
